export const SET_LISTAS = "SET_LISTAS";
